import { createRouter, createWebHistory } from 'vue-router'
import authService from '@/services/auth.service'
import LoginView from '@/views/LoginView.vue'
import MainLayout from '@/layouts/MainLayout.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard',
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
      },
      {
        path: 'journals',
        name: 'journals',
        component: () => import('@/views/JournalsView.vue'),
      },
      {
        path: 'checklists',
        name: 'checklists',
        component: () => import('@/views/ChecklistsView.vue'),
      },
      {
        path: 'checklists/instances/:id',
        name: 'checklistInstanceDetail',
        component: () => import('@/views/ChecklistInstanceDetailView.vue'),
      },
      {
        path: 'checklists/instances/:id/fill',
        name: 'fillChecklist',
        component: () => import('@/views/FillChecklistView.vue'),
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: () => import('@/views/CalendarView.vue'),
      },
      // Handbooks (Справочники)
      {
        path: 'handbooks/positions',
        name: 'positions',
        component: () => import('@/views/handbooks/PositionsView.vue'),
      },
      {
        path: 'handbooks/employees',
        name: 'employees',
        component: () => import('@/views/handbooks/EmployeesView.vue'),
      },
      {
        path: 'handbooks/workshops',
        name: 'workshops',
        component: () => import('@/views/handbooks/WorkshopsView.vue'),
      },
      {
        path: 'handbooks/equipment',
        name: 'equipment',
        component: () => import('@/views/handbooks/EquipmentView.vue'),
      },
      {
        path: 'handbooks/raw-materials',
        name: 'rawMaterials',
        component: () => import('@/views/handbooks/RawMaterialsView.vue'),
      },
      {
        path: 'handbooks/products',
        name: 'products',
        component: () => import('@/views/handbooks/ProductsView.vue'),
      },
      {
        path: 'handbooks/suppliers',
        name: 'suppliers',
        component: () => import('@/views/handbooks/SuppliersView.vue'),
      },
      {
        path: 'handbooks/work-schedule',
        name: 'workSchedule',
        component: () => import('@/views/handbooks/WorkScheduleView.vue'),
      },
      // Settings
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/views/SettingsView.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = authService.isAuthenticated()
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    // Route requires auth and user is not authenticated
    next({ name: 'login' })
  } else if (to.name === 'login' && isAuthenticated) {
    // User is authenticated and trying to access login page
    next({ name: 'dashboard' })
  } else {
    // All good, proceed
    next()
  }
})

export default router
